module.exports = __webpack_public_path__ + "cr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cr.svg
// module id = 502
// module chunks = 0